module.exports = __webpack_public_path__ + "img/o.879b5447.jpg";